import { FC } from "react";
import { MenuItem, Select, useTheme } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import __ from "src/utils/Translations";
import useIsAhr from "src/utils/hooks/useIsAhr";
import useOrgchartAreasStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/store";
import useOrgchartEmployeesStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/store";
import { OrgchartType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.models";

interface IOrgchartSelect {
  companyId: string;
}

const OrgchartSelect: FC<IOrgchartSelect> = ({ companyId }) => {
  const theme = useTheme();
  const isAhr = useIsAhr();
  const history = useHistory();
  const { orgchartType } = useParams() as { orgchartType: OrgchartType };
  const { resetField } = useFormContext();

  const handleChange = (value: OrgchartType) => {
    // Reset both stores when switching
    useOrgchartAreasStore.setState(useOrgchartAreasStore.getInitialState());
    useOrgchartEmployeesStore.setState(
      useOrgchartEmployeesStore.getInitialState()
    );
    resetField("autocomplete", { defaultValue: "" });
    history.push(
      `${
        isAhr ? "/ahr" : `/company/edit/${companyId}`
      }/organization-structure/configure-structure/structure-view/${value}`
    );
  };

  return (
    <Select
      data-testid="os__view-type-select"
      sx={{
        width: "100%",
        [theme.breakpoints.up("md")]: {
          width: "unset",
          minWidth: "300px",
        },
      }}
      onChange={(event) => {
        handleChange(event.target.value as OrgchartType);
      }}
      value={orgchartType}
      variant="outlined"
    >
      <MenuItem value={`${OrgchartType.Areas}`}>
        {__("Struktura Organizacji")}
      </MenuItem>
      <MenuItem value={`${OrgchartType.Employees}`}>
        {__("Struktura Pracownik - Przełożony ")}
      </MenuItem>
    </Select>
  );
};

export default OrgchartSelect;
